import { render, staticRenderFns } from "./goodsform.vue?vue&type=template&id=3599a23c&scoped=true&"
import script from "./goodsform.vue?vue&type=script&lang=js&"
export * from "./goodsform.vue?vue&type=script&lang=js&"
import style0 from "./goodsform.vue?vue&type=style&index=0&id=3599a23c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3599a23c",
  null
  
)

export default component.exports